import { createFileRoute, redirect } from "@tanstack/react-router";
import { sessionQueryOptions } from "@/lib/session";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData(sessionQueryOptions);
    if (session) {
      // TanStack Router uses thrown redirects as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        to: "/opportunities",
        search: { q: "", sort: "delta", order: "desc", page: 1, filter: "all" },
        replace: true,
      });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: "/login",
      search: { redirect: location.href },
      replace: true,
    });
  },
});
